import { Directive, Host, Input, OnInit, Optional } from '@angular/core';

import { CasinoTheme, DSKind, DSVariant, FeatureNames } from '@frontend/casino-ui/shared';
import { DsButton } from '@frontend/ui/button';

import { themeButtonUISettings } from './theme-button-settings';

@Directive({
    selector: '[csButton]',
    standalone: true,
})
export class ButtonWrapperDirective implements OnInit {
    @Input() featureName: FeatureNames = FeatureNames.SEARCHCANCEL;
    @Input() currentTheme: CasinoTheme = 'bwin';
    @Input() variant: DSVariant = DSVariant.Flat;
    @Input() kind: DSKind = DSKind.Tertiary;

    themeIsInverse = false;

    constructor(@Optional() @Host() private button: DsButton) {}

    ngOnInit(): void {
        const themeSetting = themeButtonUISettings[this.currentTheme];
        this.themeIsInverse = themeSetting?.button?.[this.featureName]?.isInverse ?? false;
        if (this.button) {
            this.button['variant'].set(this.variant);
            this.button['kind'].set(this.kind);
            this.button.inverse = this.themeIsInverse;
        }
    }
}
